_getCacheFromString